<template>
  <div class="container">

    <!-- SECTION TABS -->
    <div v-if="visatype" class="panel-nav" style="margin-right:1em;">
      <ul class="tab">
        <li v-for="(section, key) in sections" class="tab-item" :class="{active: secKey === key}">
          <a href="" @click.prevent="secKey = key">{{section.name}}</a>
        </li>
      </ul>
    </div>
    <!-- END SECTION TABS -->
    <div class="matterHolder">
      <div v-if="visatype && matter && section">

        <!-- SUBSECTION LOOP -->
        <div v-for="sub in section.subsections">
          <div v-if="showSub(sub)">

            <!-- REPEAT LOOP -->
            <div v-for="n in subcounts[sub.ref]" class="panel" style="margin-top:10px;">
              <div class="panel-header">
                <div class="panel-title">
                  <h3>{{sub.name}} <span v-if="n > 1">({{n}})</span></h3>
                </div>
              </div>
              <div class="panel-body">
                <div v-for="q in sub.questions" :key="q.ref" v-show="showQ(q)">
                  <textQ v-if="q.type === 'text'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></textQ>
                  <boolQ v-else-if="q.type === 'yn'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></boolQ>
                  <selectQ v-else-if="q.type === 'select'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></selectQ>
                  <dateQ v-else-if="q.type === 'date'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></dateQ>
                  <numberQ v-else-if="q.type === 'number'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></numberQ>
                  <textareaQ v-else-if="q.type === 'textarea'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></textareaQ>
                  <countryQ v-else-if="q.type === 'country'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></countryQ>
                  <languageQ v-else-if="q.type === 'language'" :matter="matter" :question="q" :answers="answers" :num="n" v-on:saved="addAns" v-on:edited="editAns"></languageQ>
                </div>
              </div>
              <button v-if="sub.repeatable && n === subcounts[sub.ref]" @click="addSub(sub)" class="btn btn-sm btn-primary float-right" style="width:155px">
                <i class="icon icon-plus"></i>Add another
              </button>
            </div>
            <!-- END REPEAT LOOP -->

          </div>
        </div>
        <!-- END SUBSECTION LOOP -->
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import utils from '@/components/utils'
import textQ from '@/components/questions/text'
import boolQ from '@/components/questions/bool'
import selectQ from '@/components/questions/select'
import dateQ from '@/components/questions/date'
import numberQ from '@/components/questions/number'
import textareaQ from '@/components/questions/textarea'
import countryQ from '@/components/questions/country'
import languageQ from '@/components/questions/language'

export default {
  name: 'client-matter',
  mixins: [utils],
  components: {
    textQ: textQ,
    boolQ: boolQ,
    selectQ: selectQ,
    dateQ: dateQ,
    numberQ: numberQ,
    textareaQ: textareaQ,
    countryQ: countryQ,
    languageQ: languageQ
  },
  data () {
    return {
      matter: null,
      visatype: null,
      answers: this.$root.$data.client.answers,
      secKey: 0,
      subcounts: null
    }
  },
  created () {
    this.setup()
  },
  computed: {
    // Return the sections with client editable subsections
    sections () {
      if (!this.visatype) return null
      return this.visatype.sections.filter(sec => {
        return sec.subsections.some(sub => {
          return sub.for_client
        })
      })
    },
    section () {
      if (typeof this.secKey === 'number') {
        return this.sections[this.secKey]
      } else {
        return null
      }
    }
  },
  watch: {
    '$route': function (to, from) {
      this.setup()
    }
  },
  methods: {
    setup () {
      // This component is reused so the state must be reset
      this.matter = null
      this.visatype = null
      this.subcounts = {}
      this.secKey = 0

      let index = this.$route.params.index || 0 // selected from sidebar
      let md = this.$root.$data.client.matters[index] // selected matter data
      this.matter = md.matter
      this.visatype = md.visatype

      this.$root.$data.pageTitle = md.matter.mattername

      // Initialise the subcounts dictionary
      this.matter.subcounts = this.matter.subcounts || {}
      this.visatype.sections.forEach(sec => {
        sec.subsections.forEach(sub => {
          this.subcounts[sub.ref] = this.matter.subcounts[sub.ref] || 1
        })
      })
    },

    // Return true if a sub or question should be shown
    showSub: function (sub) {
      if (!sub.for_client) return false
      if (!sub.depends || !sub.depends.ref) return true // No dependencies -> show
      if (!this.answers[sub.depends.ref]) return false  // Unmet dependency -> hide
      var ans = this.answers[sub.depends.ref][0]        // TODO: might have to check all answers
      if (!ans) return false
      return ans.atxt === sub.depends.atxt
    },
    showQ: function (q) {
      if (!q.depends || !q.depends.ref) return true // No dependencies -> show
      if (!this.answers[q.depends.ref]) return false  // Unmet dependency -> hide
      var ans = this.answers[q.depends.ref][0]        // TODO: might have to check all answers
      if (!ans) return false
      return ans.atxt === q.depends.atxt
    },
    // Add a newly saved answer from a child component
    addAns: function (ans) {
      let array = this.answers[ans.ref]
      if (array) {
        // There is already at least one answer to this question
        array.splice(array.length, 0, ans)
        // this.answers[ans.ref].push(ans)
      } else {
        this.answers[ans.ref] = [ans]
        this.answers = Object.assign({}, this.answers) // Force reactivity
        // Check if all questions have been answered
        utils.methods.checkMatter(this.visatype, this.matter, this.answers)
      }
    },
    editAns: function (ans) {
      if (!this.answers[ans.ref]) {
        this.answers[ans.ref] = [ans]
      } else {
        this.answers[ans.ref][ans.num - 1] = ans
      }
      this.answers = Object.assign({}, this.answers)
    },
    addSub: function (sub) {
      this.subcounts[sub.ref] += 1
      this.subcounts = Object.assign({}, this.subcounts) // Must force reactivity
      this.matter.subcounts[sub.ref] = this.subcounts[sub.ref]
      axios.post('/api/matters/update', this.matter)
    }
  }
}
</script>

<style scoped>
.matterHolder {
  padding: 0 0 4em 0;
}
.panel .btn.btn-sm {
  margin: 2em 0 1em 1em;
}
.panel .btn.btn-sm i {
  margin: 0 .5em 0 0;
}
</style>



// WEBPACK FOOTER //
// clientMatter.vue?4543b317